export const IMAGES = {
  heroInfusion:
    "https://images.unsplash.com/photo-1746806942787-947eebe640d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHozfHxtZWRpY2FsJTIwaW5mdXNpb24lMjBob3NwaXRhbCUyMHBhdGllbnQlMjBjYXJlJTIwd2FybSUyMGh1bWFuJTIwY2FyZWdpdmVyJTIwZG9jdG9yJTIwaGFuZHN8ZW58MHx8fHwxNzkyMzEwNjQyfDA&ixlib=rb-4.1.0&q=85",
  patientCare:
    "https://images.pexels.com/photos/3845115/pexels-photo-3845115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  doctorConsult:
    "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjYXJpbmclMjBkb2N0b3IlMjB0YWxraW5nJTIwdG8lMjBwYXRpZW50JTIwY29tcGFzc2lvbmF0ZSUyMG1lZGljYWwlMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzkyMzEwNjQ5fDA&ixlib=rb-4.1.0&q=85",
  doctorTalking:
    "https://images.pexels.com/photos/7579831/pexels-photo-7579831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cochin:
    "https://images.unsplash.com/photo-1580424560349-a8929a705c58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxob3NwaXRhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwZmFjaWxpdHklMjBmcmFuY2UlMjBwYXJpc3xlbnwwfHx8fDE3OTIzMTA2NDh8MA&ixlib=rb-4.1.0&q=85",
  beaujon:
    "https://images.unsplash.com/photo-1586335939231-c497a2c94a9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxob3NwaXRhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwZmFjaWxpdHklMjBmcmFuY2UlMjBwYXJpc3xlbnwwfHx8fDE3OTIzMTA2NDh8MA&ixlib=rb-4.1.0&q=85",
  pneumologie:
    "https://images.unsplash.com/photo-1512468596237-e6ec7a357938?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxob3NwaXRhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwZmFjaWxpdHklMjBmcmFuY2UlMjBwYXJpc3xlbnwwfHx8fDE3OTIzMTA2NDh8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "1/1 M", label: "Cas répertoriés", description: "Environ une personne sur un million : une maladie chronique rare de la circulation lymphatique", id: "stat-rarity" },
  { value: "1× / semaine", label: "Fréquence des perfusions", description: "Pour compenser les pertes en protéines et défenses immunitaires", id: "stat-infusions" },
  { value: "3 centres", label: "Hôpitaux partenaires", description: "Cochin, Beaujon et un service de pneumologie expérimentés", id: "stat-hospitals" },
  { value: "100 %", label: "Soutien gratuit", description: "Accompagnement des malades et de leurs proches", id: "stat-support" },
];

export const HOSPITALS = [
  {
    name: "Hôpital Cochin (AP-HP)",
    city: "Paris 14ᵉ",
    specialty: "Service de médecine interne",
    description:
      "Le service de médecine interne de l'hôpital Cochin suit la maladie de Waldmann : diagnostic, coordination du parcours de soins, suivi des perfusions et lien avec le médecin traitant.",
    image: IMAGES.cochin,
    id: "hospital-cochin",
  },
  {
    name: "Hôpital Beaujon (AP-HP)",
    city: "Clichy (92)",
    specialty: "Service de gastro-nutrition",
    description:
      "Le service de gastro-nutrition de l'hôpital Beaujon connaît très bien la maladie de Waldmann : expertise reconnue dans la gestion des pertes protéiques, l'alimentation adaptée et le suivi nutritionnel au long cours.",
    image: IMAGES.beaujon,
    id: "hospital-beaujon",
  },
  {
    name: "Service de pneumologie",
    city: "Région parisienne",
    specialty: "Complications respiratoires & lymphatiques",
    description:
      "Prise en charge des complications thoraciques possibles de la maladie (épanchements, chylothorax), en lien étroit avec les équipes de médecine interne et de gastro-nutrition.",
    image: IMAGES.pneumologie,
    id: "hospital-pneumologie",
  },
];

export const ARTICLES = [
  {
    slug: "comprendre-la-maladie-de-waldmann",
    title: "Comprendre la maladie de Waldmann en 5 minutes",
    date: "2026-06-12",
    category: "Comprendre",
    excerpt:
      "Lymphangiectasie intestinale primitive : un nom compliqué pour une maladie rare que l'on peut expliquer simplement.",
    content: [
      "La maladie de Waldmann, ou lymphangiectasie intestinale primitive, est une maladie rare des vaisseaux lymphatiques de l'intestin. Ces vaisseaux, dilatés, laissent fuir la lymphe — un liquide riche en protéines et en cellules immunitaires — dans le tube digestif.",
      "Cette fuite entraîne une perte de protéines (dont les immunoglobulines qui nous défendent contre les infections), des œdèmes, des troubles digestifs et une grande fatigue. La maladie peut apparaître dès l'enfance comme à l'âge adulte.",
      "Il n'existe pas de traitement curatif à ce jour, mais la prise en charge est réelle : perfusions régulières d'immunoglobulines ou d'albumine, alimentation adaptée pauvre en graisses à longue chaîne, et suivi hospitalier rapproché permettent de vivre avec la maladie au quotidien.",
      "Si vous ou un proche êtes concerné, n'hésitez pas à nous contacter : notre association est là pour écouter, informer et accompagner.",
    ],
  },
  {
    slug: "journee-mondiale-maladies-rares-2026",
    title: "Journée mondiale des maladies rares : mobilisons-nous",
    date: "2026-02-28",
    category: "Événement",
    excerpt:
      "Le 28 février, la communauté des maladies rares se rassemble. Retour sur notre participation et nos actions de sensibilisation.",
    content: [
      "Chaque année, la Journée mondiale des maladies rares est un moment essentiel pour donner de la visibilité aux 3 millions de Français concernés — dont les personnes atteintes de la maladie de Waldmann.",
      "Cette année, notre association a tenu un stand d'information à Sarcelles : distribution de plaquettes, échanges avec le public et témoignages de malades. Beaucoup découvraient l'existence de cette maladie pour la première fois.",
      "Faire connaître la maladie, c'est aussi faire avancer le diagnostic : trop de patients attendent des années avant que leur maladie soit nommée. Merci à tous les bénévoles mobilisés !",
    ],
  },
  {
    slug: "bien-vivre-avec-les-perfusions-hebdomadaires",
    title: "Bien vivre avec les perfusions hebdomadaires",
    date: "2026-01-20",
    category: "Conseils",
    excerpt:
      "Organisation, alimentation, moral : nos conseils pratiques pour apprivoiser le rythme des soins hebdomadaires.",
    content: [
      "Quand les perfusions rythment chaque semaine, l'organisation devient une alliée précieuse. Prévoir ses trajets, anticiper les ordonnances, garder un carnet de suivi à jour : autant de réflexes qui allègent le quotidien.",
      "Côté alimentation, un régime pauvre en graisses à longue chaîne, enrichi en triglycérides à chaîne moyenne (TCM), est souvent recommandé par les équipes médicales. Un suivi diététique régulier aide à adapter les repas sans se priver.",
      "Le moral compte autant que le corps : parler de la maladie, rejoindre un groupe de parole, partager avec d'autres malades qui comprennent vraiment — c'est toute la mission de notre association.",
      "Besoin d'en parler ? Appelez-nous au 09 54 24 34 46, nous sommes là.",
    ],
  },
  {
    slug: "ou-vont-vos-dons",
    title: "Où vont vos dons ? Notre engagement de transparence",
    date: "2025-12-05",
    category: "Transparence",
    excerpt:
      "Aide aux malades, soutien alimentaire et financier, sensibilisation : découvrez concrètement comment chaque euro donné est utilisé.",
    content: [
      "Chaque don compte, et nous nous engageons à l'utiliser avec la plus grande transparence. Concrètement, vos dons financent trois piliers.",
      "D'abord, l'aide directe aux malades : soutien alimentaire et financier au quotidien, aide aux déplacements pour les perfusions hebdomadaires, écoute et accompagnement des familles.",
      "Ensuite, la sensibilisation : plaquettes d'information, stands, campagnes pour faire connaître la maladie de Waldmann auprès du grand public et des professionnels de santé.",
      "Enfin, l'amélioration de la prise en charge : soutien aux initiatives qui facilitent le parcours de soins et la recherche d'informations médicales fiables sur cette maladie rare.",
      "Merci de votre confiance. Un reçu fiscal vous est délivré pour chaque don : 66 % de son montant est déductible de vos impôts.",
    ],
  },
];

export const RESOURCES = [
  {
    title: "Orphanet",
    description: "Le portail européen des maladies rares : fiche détaillée sur la lymphangiectasie intestinale primitive.",
    url: "https://www.orpha.net",
  },
  {
    title: "Alliance Maladies Rares",
    description: "La fédération française des associations de maladies rares : droits, démarches, accompagnement.",
    url: "https://alliance-maladies-rares.org",
  },
  {
    title: "AP-HP",
    description: "L'Assistance Publique – Hôpitaux de Paris, dont font partie les hôpitaux Cochin et Beaujon.",
    url: "https://www.aphp.fr",
  },
  {
    title: "Haute Autorité de Santé",
    description: "Recommandations et protocoles de soins pour les maladies rares.",
    url: "https://www.has-sante.fr",
  },
];
